import React, { useState } from "react";
import {
  Box,
  TextField,
  Chip,
  IconButton,
  Typography,
  InputAdornment,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { colors } from "../../theme/theme";

const CustomTagInput = ({
  hashTags,
  setHashTags,
  width,
  label,
  color,
  mT,
  Icon,
  noIcon,
  placeholder,
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleAddTag = () => {
    if (inputValue.trim() && !hashTags.includes(inputValue.trim())) {
      setHashTags([...hashTags, inputValue.trim()]);
      setInputValue("");
    }
  };

  const handleDeleteTag = (tagToDelete) => {
    setHashTags(hashTags.filter((tag) => tag !== tagToDelete));
  };

  return (
    <Box sx={{ mb: 2, width: width || "100%", mt: mT || 0 }}>
      {label && (
        <Typography
          sx={{
            fontFamily: "Mulish-Regular",
            fontSize: "12px",
            color: colors.textColor,
            fontWeight: "700",
            mb: 0.5,
            textTransform: "uppercase",
            textAlign: "left",
          }}
        >
          {label}
        </Typography>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "transparent",
          fontFamily: "Mulish-Regular",
          fontSize: "14px",
          fontWeight: "400",
          color: color || colors.primary,
          borderRadius: "9px",
          border: `1px solid ${colors.secondary}}`,
          pt: "auto",
          height: "null",
          flexWrap: "wrap",
          overflowX: "scroll",
          overflowY: "hidden",
          whiteSpace: "nowrap",
          "&::-webkit-scrollbar": { height: "6px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#ccc",
            borderRadius: "4px",
          },
          "& .MuiOutlinedInput-input": {
            color: color || colors.primary,
          },
        }}
      >
        <TextField
          fullWidth
          sx={{
            width: "100%",
            fontFamily: "Mulish-Regular",
            fontSize: "14px",
            fontWeight: "400",
            borderRadius: "0px",
            ml: "0px",
            "& .MuiOutlinedInput-root": {
              color: color || colors.primary,
              borderRadius: "0px",
              border: "0px",
            },
            border: "0px",
          }}
          placeholder={placeholder || "Add a tag"}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddTag()}
          InputProps={{
            sx: {
              height: "50px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "0px",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "0px",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "0px",
              },
              "& .MuiInputAdornment-root": {
                color: color || "red",
              },
            },
            startAdornment: (
              <>
                {!noIcon && (
                  <InputAdornment
                    position="start"
                    sx={{
                      paddingRight: "5px",
                    }}
                  >
                    <Icon
                      sx={{
                        color: colors.textColor,
                        fontSize: "20px",
                      }}
                    />
                  </InputAdornment>
                )}
              </>
            ),
            endAdornment: (
              <IconButton sx={{ ml: 1 }} onClick={handleAddTag}>
                <AddIcon sx={{ color: color || colors.primary }} />
              </IconButton>
            ),
          }}
          InputLabelProps={{
            shrink: false,
          }}
        />
      </Box>
      {hashTags.map((tag, index) => (
        <Chip
          key={index}
          label={tag}
          onDelete={() => handleDeleteTag(tag)}
          sx={{
            mx: 0.5,
            my: 1,
            backgroundColor: colors.secondary,
            color: "#fff",
            fontWeight: "500",
            "& .MuiChip-deleteIcon": {
              color: "#fff",
              opacity: 1,
            },
            "&:hover": {
              backgroundColor: colors.secondary + "33",
              "& .MuiChip-deleteIcon": {
                color: "#fff",
                opacity: 1,
              },
            },
          }}
        />
      ))}
    </Box>
  );
};

export default CustomTagInput;
